<template>
  <v-container fluid class="docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Containers List</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="accent" small to="/new-freight-container">
            <v-icon left dark>mdi-plus</v-icon>New Container
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :headers="headers"
              :items="stores"
              :search="search"
              :mobile-breakpoint="0"
            >
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn
                  color="editIcon"
                  text
                  :to="`/edit-freight-container/${item.id}`"
                  icon
                  ><v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->
              <!-- manifest template -->
              <template v-slot:item.manifest="{ item }">
                <v-btn
                  v-if="item.ManifestCreated == 'N'"
                  color="accent"
                  text
                  @click="openManifestDialog(item)"
                  ><v-icon left>mdi-plus</v-icon>
                  Create Manifest
                </v-btn>

                <v-btn
                  :to="`/freight/containers/manifest/${item.id}`"
                  v-else
                  color="primary"
                  text
                  ><v-icon left>mdi-eye</v-icon>
                  View Manifest
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>

          <!-- summary dialog -->
          <v-dialog
            v-model="manifestDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar dark color="primary" dense>
                <v-toolbar-title>
                  <v-btn icon dark @click.native="manifestDialog = false">
                    <v-icon dark>mdi-keyboard-backspace</v-icon>
                  </v-btn>
                  Manifest Creation
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click.native="manifestDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-container class="docForm">
                  <v-row justify="center" class="mt-5 subtitle-2 text--primary">
                    <v-col cols="12" xs="12" md="3">
                      <span style="color: red">
                        Container No: {{ activeContainer.Name }}</span
                      ><br />
                      <span>Date Received: {{ activeContainer.DocDate }}</span>
                    </v-col>

                    <v-col cols="12" xs="12" md="2">
                      <span style="color: red">
                        Total Lines: {{ activeContainer.Lines }}</span
                      >
                    </v-col>

                    <v-col cols="12" xs="12" md="3">
                      <span>
                        Cost / Line:
                        {{
                          activeContainer.LineCost &&
                          activeContainer.LineCost.toLocaleString()
                        }}</span
                      >
                    </v-col>

                    <v-col cols="12" xs="12" md="2">
                      <span
                        >Total Value:
                        {{
                          (
                            activeContainer.Lines * activeContainer.LineCost
                          ).toLocaleString()
                        }}</span
                      >
                    </v-col>

                    <v-col cols="12" xs="12" md="10">
                      <v-data-table
                        :mobile-breakpoint="0"
                        :items-per-page="500"
                        :headers="manifestHeaders"
                        :items="manifestData"
                        :search="search"
                        hide-default-footer
                        disable-sort
                      >
                        <!-- customer name  -->
                        <template v-slot:item.CustomerName="{ item }">
                          <div style="width: 200px; margin-right: 20px">
                            {{ item.CustomerName }}
                          </div>
                        </template>
                        <!-- end of customer name  -->

                        <!-- Phone Number  -->
                        <template v-slot:item.PhoneNumber="{ item }">
                          <div style="width: 150px; margin-right: 20px">
                            {{ item.PhoneNumber }}
                          </div>
                        </template>
                        <!-- end of Phone Number  -->

                        <!-- lines input -->
                        <template v-slot:item.Lines="{ item }">
                          <v-text-field
                            autocomplete="off"
                            type="number"
                            class="orderInput"
                            @input="inputChanged(item)"
                            single-line
                            outlined
                            dense
                            v-model="item.Lines"
                          ></v-text-field>
                        </template>
                        <!-- end of lines input -->

                        <!-- lines input -->
                        <template v-slot:item.LineCost="{ item }">
                          <div
                            style="
                              width: 150px;
                              margin-right: 20px;
                              margin-left: 20px;
                            "
                          >
                            {{
                              item.LineCost && item.LineCost.toLocaleString()
                            }}
                          </div>
                        </template>
                        <!-- end of lines input -->

                        <!-- lines input -->
                        <template v-slot:item.DocTotal="{ item }">
                          <div style="width: 150px; margin-right: 20px">
                            {{
                              item.DocTotal && item.DocTotal.toLocaleString()
                            }}
                          </div>
                        </template>
                        <!-- end of lines input -->

                        <!-- action template -->
                        <template v-slot:item.action="{ item }">
                          <v-btn @click="deleteRow(item)" color="red" icon>
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <!-- end -->
                      </v-data-table>
                    </v-col>

                    <v-col cols="12" xs="12" md="5">
                      <v-autocomplete
                        style="width: 350px"
                        autocomplete="off"
                        v-model="selectedCustomer"
                        :items="customers"
                        @change="setOrderItem(selectedCustomer)"
                        item-text="Name"
                        item-value="id"
                        cache-items
                        class="mt-2"
                        flat
                        label="Select Customer"
                        outlined
                        dense
                      >
                        <template v-slot:no-data>
                          <v-row align="center" justify="center">
                            <v-btn
                              class="ma-2"
                              color="accent"
                              dark
                              small
                              elevation="0"
                              @click="customerModal()"
                            >
                              <v-icon left>mdi-plus</v-icon>Create A Customer
                            </v-btn>
                          </v-row>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="12" xs="12" md="5">
                      <v-btn
                        @click="saveManifest"
                        class="float-right"
                        color="accent"
                        ><v-icon left>mdi-content-save</v-icon>Create
                        Manifest</v-btn
                      >
                    </v-col>

                    <v-col cols="12" xs="12" md="10">
                      <div>Manifest Lines (Computed): {{ manifestLines }}</div>
                      <div>
                        Manifest Total (Computed):
                        {{ manifestValue.toLocaleString() }}
                      </div>
                      <div>
                        <span style="color: red"
                          >Line Difference:
                          {{ activeContainer.Lines - manifestLines }}</span
                        >
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- Customer quick add dialog modal-->
          <v-dialog v-model="customerDialog" max-width="750px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Create A Customer</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="customerDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <customer-editor
                    :initial="customerItem"
                    @data="saveCustomer"
                  ></customer-editor>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of modal-->

          <snackbar ref="snackbar"></snackbar>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import CustomerEditor from "@/components/subscriber/customers/_components/quick-editor.vue";
export default {
  components: {
    CustomerEditor,
  },
  data: () => ({
    search: "",
    loader: false,
    activeContainer: {},
    manifestDialog: false,
    selectedCustomer: null,
    customers: [],
    recordDialog: false,
    customerDialog: false,
    customerItem: {},
    manifestItem: {},
    manifestData: [],
    headers: [
      { text: "Container Label", value: "Name" },
      { text: "Total Lines", value: "Lines" },
      { text: "Cost / Line", value: "LineCost" },
      { text: "Date", value: "DocDate" },
      { text: "Action", value: "action" },
      { text: "Manifest", value: "manifest" },
    ],
    manifestHeaders: [
      { text: "Customer", value: "CustomerName" },
      { text: "Phone Number", value: "PhoneNumber" },
      { text: "Line(s)", value: "Lines" },
      { text: "Cost / Line", value: "LineCost" },
      { text: "Total", value: "DocTotal" },
      { text: "Action", value: "action" },
    ],
    stores: [],
  }),
  computed: {
    manifestValue() {
      let total = 0;
      if (
        typeof this.manifestData != "undefined" &&
        this.manifestData.length > 0
      ) {
        return this.manifestData
          .map((item) => {
            let Lines;
            let LineCost;
            if (item.Lines) {
              Lines = item.Lines;
            } else {
              Lines = 0;
            }

            if (item.LineCost) {
              LineCost = item.LineCost;
            } else {
              LineCost = 0;
            }

            const amount = Lines * LineCost;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    manifestLines() {
      let total = 0;
      if (
        typeof this.manifestData != "undefined" &&
        this.manifestData.length > 0
      ) {
        return this.manifestData
          .map((item) => {
            let Lines;
            if (item.Lines) {
              Lines = item.Lines;
            } else {
              Lines = 0;
            }

            total = +Lines;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
  },
  methods: {
    addRecord() {},
    customerModal() {
      this.customerDialog = true;
    },
    inputChanged(data) {
      let Lines;
      let LineCost;
      if (data.Lines) {
        Lines = parseFloat(data.Lines);
      } else {
        Lines = 0;
      }
      if (data.LineCost) {
        LineCost = parseFloat(data.LineCost);
      } else {
        LineCost = 0;
      }

      const DocTotal = Lines * LineCost;

      // find item
      const currentItem = this.manifestData.find((record) => {
        return record.LineNum === data.LineNum;
      });
      const pos = this.manifestData.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      // end of find

      currentItem.DocTotal = DocTotal;
      this.manifestData[pos] = currentItem;
    },
    openManifestDialog(data) {
      this.activeContainer = data;
      this.manifestDialog = true;
    },
    deleteRow(item) {
      const selectedRow = this.manifestData.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.manifestData.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.manifestData.splice(pos, 1);
    },
    setOrderItem(id) {
      const self = this;
      // fetch the product from database
      this.$store
        .dispatch("get", `/customers/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            const customer = res.ResponseData;
            // current item definition
            let currentItem = {};

            // set price list
            const LineNum = new Date().getTime();
            currentItem.LineNum = LineNum;
            currentItem.CardCode = customer.id;
            currentItem.CustomerName = customer.Name;
            currentItem.PhoneNumber = customer.PhoneNumber;
            currentItem.Lines = null;
            currentItem.LineCost = self.activeContainer.LineCost;
            currentItem.DocTotal = 0;
            // end

            let initArray = [];
            initArray.push(currentItem);
            self.manifestData = [...self.manifestData, ...initArray];
            self.selectedCustomer = null;
          } else {
            self.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    saveCustomer(data) {
      const url = "/customers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            const customer = res.ResponseData;
            self.customers = [...this.customers, customer];
            self.$refs.snackbar.show("Customer Added Successully", "green");
            self.customerDialog = false;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
          self.$store.commit("btnLoader", false);
        });
    },
    saveManifest() {
      // if (this.activeContainer.Lines != this.manifestLines) {
      //   this.$refs.snackbar.show("Container Lines Don't match!", "red");
      // } else {
      const self = this;
      let data = {
        store_id: self.activeContainer.id,
        DocDate: new Date().toISOString().substr(0, 10),
        rows: self.manifestData,
      };
      const url = "/manifest";
      self.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$router.push(
              `/freight/containers/manifest/${self.activeContainer.id}`
            );
            self.loader = false;
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
      // }
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/get/containers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            const customers = res.ResponseData;
            customers.shift();
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getStores();
    this.getCustomers();
  },
};
</script>